import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { Observer } from 'gsap/Observer'

export default defineNuxtPlugin(() => {
  gsap.registerPlugin(Observer)

  if (process.client) {
    gsap.registerPlugin(Draggable)
  }

  return {
    provide: {
      gsap,
      Observer,
      Draggable,
    },
  }
})
